module.exports = __webpack_public_path__ + "static/img/cleverid.7eed9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cleverid.png
// module id = VcJx
// module chunks = 1